/**
 * A news category managed in the CMS. News items reference it by id, so a rename shows on every
 * news item without changing them.
 */
export interface NewsCategory {
  id: string;
  name: NewsCategoryName;
}

export interface NewsCategoryName {
  nl: string;
  en: string;
}

/** The category name in the given language, falling back to Dutch for any other language. */
export function localisedCategoryName(category: NewsCategory, language: string | null | undefined): string {
  return language === 'en' ? category.name.en : category.name.nl;
}
